import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
type Props = {
    id:number;
    gramam_name: string;
    gramams_formed: number;
    members_registered :number;
    total_gramas_count:number;
    total_gramas_formed:number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
};
export const GramamSthayiReportCard: React.FC<Props> = ({ id,total_gramas_formed,total_gramas_count, nagar_type,gramam_name,gramams_formed,members_registered,total_basti ,total_gramas}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // const handleCardClick = (id) => {
    //     // dispatch(activateMenu(path))
    //     localStorage.setItem('gramam_name',gramam_name)
    //     navigate('/samithi_members/'+id, { replace: true });
    // }
let upMandalName=localStorage.getItem('upamandal_name')

    return (
        <Col md={4} xl={3} xs={6} className="mb-4" >
      <Card className=" shadow h-100 py-2" style={{ borderLeft: "5px solid #fd803a"}}>
      <Card.Body style={{padding :"2rem"}}>
                    <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                            <div className="text-xl font-weight-bold  text-uppercase mb-1" style={{color:"#fd803a"}}>
                                <p>{upMandalName}</p></div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            <p>{total_gramas_formed} Over  /  {total_gramas_count} Total Villages</p>
                        </div>

                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

